{
  "#PMS_ARBEITSBERICHT_STATISTIK": {
    "PAGES": {
      "QUERY": {
        "SUBMIT": "Query"
      },
      "RESULT": {
        "TITLE": "Result"
      }
    },
    "DIALOGS": {
      "EDIT_DATE": {
        "TITLE": "Edit Date",
        "CANCEL": "Cancel",
        "SAVE": "Save"
      },
      "EDIT_FOK": {
        "TITLE": "Edit Field-Ok",
        "CANCEL": "Cancel",
        "SAVE": "Save"
      },
      "EDIT_SELECT": {
        "TITLE": "Edit Level",
        "CANCEL": "Cancel",
        "SAVE": "Save"
      }
    },
    "TITLE": "Work Report Statistics",
    "HEADER_TITLE": "Level",
    "LABEL_EBENE": "Level",
    "LABEL_ID": "ID",
    "LABEL_GROUP": "Group",
    "LABEL_VON_DATUM": "From Date",
    "LABEL_BIS_DATUM": "To Date",
    "LABEL_MITARBEITER": "Employee",
    "LABEL_PERSONALNUMMER": "Employee Number",
    "LABEL_BESCHREIBUNG": "Description",
    "LABEL_ARBEITSZEIT": "Working Time",
    "LABEL_VERRZEIT": "Overtime",
    "LABEL_DATUM": "Date",
    "LABEL_OBJEKT": "Object",
    "LABEL_OBJEKTGRUPPE": "Object Group",
    "LABEL_KUNDE": "Customer",
    "LABEL_KUNDENGRUPPE": "Customer Group",
    "LABEL_ABTEILUNG": "Department",
    "LABEL_KOSTENSTELLE": "Cost Center",
    "LABEL_LEITER": "Manager",
    "LABEL_STUNDEN": "Hours",
    "LABEL_KZVERRZEIT": "Overtime Code",
    "LABEL_TSUM_STUNDEN": "TSUM Hours",
    "LABEL_TVR_SUM": "TVR SUM",
    "LABEL_BEMERKUNG": "Remark",
    "LABEL_TICKET": "Ticket",
    "LABEL_TICKET_TYP": "Ticket Type",
    "LABEL_COBIT": "Cobit Category",
    "LABEL_IS_CVS": "CVS",
    "LABEL_IS_COPIED": "Copied",
    "LABEL_PLANZEIT": "Planned Time",
    "LABEL_DIFFZEIT": "Diff. Time",
    "LABEL_DP": "On Schedule",
    "LABEL_TICKETS": "Tickets",
    "LABEL_GESAMT": "Total",
    "LABEL_PRODUKTIV": "Productive",
    "LABEL_AUFTRAG": "Order",
    "LABEL_REGIE": "On Demand",
    "LABEL_LIEFERSCHEIN": "Delivery Note",
    "LABEL_WARTUNG": "Maintenance",
    "LABEL_KEINE": "None",
    "LABEL_ENTWICKLUNG": "Development",
    "LABEL_INTERN": "Internal",
    "LABEL_VERRZEIT_RA": "Billed",
    "LABEL_VERRZEIT_RNA": "Not Billed",
    "LABEL_GESCHLOSSEN": "Closed",
    "LABEL_OFFEN": "Open",
    "LABEL_TICKETS_GESCHLOSSEN": "Tickets Closed",
    "LABEL_TICKETS_OFFEN": "Tickets Open",
    "LABEL_TICKETS_GESCHLOSSEN_PLANZEIT": "Planned Time Exceeded (Closed)",
    "LABEL_TICKETS_OFFEN_PLANZEIT": "Planned Time Exceeded (Open)",
    "EBENE": {
      "FIRMA": "Company",
      "ABTEILUNG": "Departments",
      "MITARBEITER": "Employees",
      "OBJEKT": "Objects",
      "KOSTENSTELLE": "Cost Centers",
      "KUNDE": "Customers",
      "KUNDENGRUPPE": "Customer Groups",
      "OBJEKTGRUPPE": "Object Groups",
      "LEITER": "Managers",
      "EINZELN": "Individual"
    },
    "NO_DATA": "No data available to display"
  }
}
